import React from 'react';
import TitleUndescore from 'modules/shared/TitleUndescore';
import { Checkbox } from 'modules/shared/Forms';
import styles from './SettingsDocumentsCard.module.scss';

type Props = {
  onChange: (e: React.ChangeEvent<any>) => void;
};

const SettingsDocumentsCard: React.FC<Props> = ({ onChange }) => (
  <div className="my-5">
    <TitleUndescore title="Обов'язкова реєстрація" />
    <div className="pl-4">
      <div className={styles.docRow}>
        <span className={styles.docLabel}>Документи водія/експедитора:</span>
        <Checkbox name="useVisitorDoc" label="" className={styles.checkbox} onChange={onChange} />
      </div>
      <div className={styles.docRow}>
        <span className={styles.docLabel}>Документи авто/причепу:</span>
        <Checkbox name="useTransportDoc" label="" className={styles.checkbox} onChange={onChange} />
      </div>
    </div>
  </div>
);

export default SettingsDocumentsCard;
